import type { CodeParams } from "@whilecat/core/tasks/common/params/code-task-params.ts";
import { ParamsValidator } from "@whilecat/core/tasks/validators/params-validator.js";
import { isBlank, isNotBlank } from "@whilecat/core/utils/string.js";
import { sanityCheck } from "@whilecat/core/utils/validation.js";

export abstract class JavaParamsValidator<T> extends ParamsValidator<T> {
    abstract validate(params: T & CodeParams): void;

    protected basicValidation(data: T & CodeParams): void {
        if (data.exampleTask) {
            sanityCheck(data.repeatableRun, "example tasks must have repeatable run flag enabled");
            sanityCheck(!data.showAnswerButtonEnabled, "show answer button must be disabled to example tasks");
            sanityCheck(isBlank(data.correctCode), "correct code must be blank for example tasks");
        } else {
            sanityCheck(data.showAnswerButtonEnabled, "practice tasks must have possibility to show correct code");
            sanityCheck(data.editable, "practice tasks must be editable");
        }

        if (data.editable) {
            sanityCheck(
                data.exampleTask || isNotBlank(data.correctCode),
                "editable tasks must have either correct code or be example ones",
            );
        }

        if (data.showAnswerButtonEnabled) {
            sanityCheck(isNotBlank(data.correctCode), "correct code must be present for practice tasks");
        }
    }
}
